module.exports = __webpack_public_path__ + "img/no.026d3cd7.svg";